import { Search } from 'lucide-react';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = 'Поиск',
  value,
  onChange,
}) => {
  return (
    <div
      className="h-9 rounded-[10px] flex items-center px-3 gap-2"
      style={{ backgroundColor: 'var(--bg-secondary)' }}
    >
      <Search size={16} style={{ color: 'var(--text-hint)' }} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="flex-1 bg-transparent border-none outline-none text-[17px]"
        style={{
          color: 'var(--text-primary)',
        }}
      />
      <style>{`
        input::placeholder {
          color: var(--text-hint);
        }
      `}</style>
    </div>
  );
};
